import { useEffect } from "react";
import useTranslator from "../../hooks/useTranslator";
import styles from "./authenticateYourId/authenticateYourId.module.css";

const KycVerificationPopup = ({
  loadUser,
  showPopup,
  setKycVerificationPopup,
  isGuarantor,
}) => {
  const { _t } = useTranslator();

  useEffect(() => {
    if (showPopup) {
      setTimeout(async () => {
        await loadUser();
        setKycVerificationPopup(false);
      }, 5000);
    }
  }, []);

  return (
    <>
      {showPopup && (
        <div
          className={`${styles.overlay} popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${isGuarantor ? "guarantorBg" : ""}`}
          style={{ zIndex: 100 }}
        >
          <div
            className={`popup-content2 popup-content bg-white ${styles.kycSubmittedPopup} ${styles.authModalSurface}`}
          >
            <div className={styles.kycSubmittedIconWrapper}>
              <div className={styles.kycSubmittedIconCircle}>
                <img
                  src="/images/document.svg"
                  alt="Document Icon"
                  className={styles.kycSubmittedIcon}
                />
              </div>
            </div>

            <div className={`text-center ${styles.kycSubmittedHeader}`}>
              <h4>{_t("kycAnimationScreenTitle")}</h4>
              <p>{_t("kycAnimationScreenDescription")}</p>
              <p>{_t("kycAnimationScreenSubDescription")}</p>
            </div>

            <div className={styles.kycStatusIndicator}>
              <span
                className={`${styles.kycStatusDot} ${styles.kycStatusDotOne}`}
              ></span>
              <span
                className={`${styles.kycStatusDot} ${styles.kycStatusDotTwo}`}
              ></span>
              <span
                className={`${styles.kycStatusDot} ${styles.kycStatusDotThree}`}
              ></span>
              <span className={styles.kycStatusLabel}>{_t("inReview")}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default KycVerificationPopup;
